import { Platform } from "react-native";
import { setChatInterface } from "../../Redux/Reducers/appPreservedConfigReducer";



export const initializeChat = () => {


  return async (dispatch, getState) => {
    try {
      const { chatInterface } = getState().appPreservedConfigSlice;

      // here make sure to make chat Initialized true dispatch(setChatInterface({chatInitialized: true}));
      if(chatInterface?.interfaceKey?.toLowerCase() == "innspirechat"){
        dispatch(setChatInterface({chatInitialized: true}));
      }

    } catch (error) {
      console.log("Error while initializing chat", error)
    }
  }
}

export const handleOpenChat = () => {

  return async (dispatch, getState) => {
    try {
      const { chatInterface } = getState().appPreservedConfigSlice;

      if(chatInterface?.interfaceKey?.toLowerCase() == "innspirechat"){

        // if(Platform.OS == "android"){
        //   const { PermissionsAndroid } = await import('react-native');
        //   await PermissionsAndroid.request(
        //     PermissionsAndroid.PERMISSIONS.RECORD_AUDIO
        //   );
        // }

        dispatch(setChatInterface({showConversation: true}));
      }

    } catch (error) {
      console.log("Error while opening chat", error)
    }
  }
}